const fdicDisclaimerStrings = {
  fdicInfo:
    'FDIC-Insured – Backed by the full faith and credit of the U.S. Government',
};

export default fdicDisclaimerStrings;
